import { Observable, Subscription } from 'rxjs';
import {
  Event,
  GuardsCheckEnd,
  GuardsCheckStart,
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  NavigationStart,
} from '@angular/router';

/** Seuil sous lequel une navigation est jugée instantanée : pas d'overlay. */
const SEUIL_MS = 120;

interface Chargement {
  startLoading(): void;
  stopLoading(): void;
}

/**
 * Loader global pendant une navigation (chunk lazy, resolvers), avec un seuil
 * pour ne pas flasher sur les navigations instantanées.
 *
 * Il est suspendu pendant l'exécution des gardes : une garde de sortie qui
 * demande confirmation attend une réponse de l'utilisateur, et l'overlay
 * recouvrait la boîte de dialogue — impossible de cliquer « Rester » ou
 * « Quitter ». Il reprend une fois les gardes passées.
 */
export function suivreNavigation(events: Observable<Event>, loader: Chargement): Subscription {
  let minuteur: ReturnType<typeof setTimeout> | undefined;
  let affiche = false;

  const armer = (): void => {
    desarmer();
    minuteur = setTimeout(() => {
      minuteur = undefined;
      loader.startLoading();
      affiche = true;
    }, SEUIL_MS);
  };

  const desarmer = (): void => {
    if (minuteur) {
      clearTimeout(minuteur);
      minuteur = undefined;
    }
  };

  const retirer = (): void => {
    desarmer();
    if (affiche) {
      loader.stopLoading();
      affiche = false;
    }
  };

  return events.subscribe((event) => {
    if (event instanceof NavigationStart) {
      armer();
    } else if (event instanceof GuardsCheckStart) {
      retirer();
    } else if (event instanceof GuardsCheckEnd) {
      if (event.shouldActivate) {
        armer();
      }
    } else if (
      event instanceof NavigationEnd ||
      event instanceof NavigationCancel ||
      event instanceof NavigationError
    ) {
      retirer();
    }
  });
}
